import React from 'react';
import './index.css';
import SiderMenu from '@pages/Assembly/siderMenu';
import { Flex } from '@components';
import { Button, Modal, message } from 'antd';
import { mkbz } from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import { getLoginUser } from '@utils/NHCore';
import NHFetch from "../../../../utils/NHFetch";
import CommonTip from "../common";
import NextButton from '@pages/SelfHelp/common/nextIndex'

/** 参数标识配置常量 */
const CONFIG = {
    /** 入学须知倒计时秒数参数标识 */
    COUNTDOWN_CSZB: 'TSXY_YXWZ_RXXZDJS',
    /** 入学须知是否强制阅读参数标识 */
    FORCE_READ_CSZB: 'TSXY_YXWZ_RXXZSFQZYD',
    /** 强制阅读参数值：是 */
    FORCE_READ_YES: '是',
};

/**
 * 判断配置值是否表示"是"
 * 兼容多种存储形式：'是' / '1' / 'true' / true
 * @param {*} value — 配置值
 * @returns {boolean}
 */
const isValueYes = (value) => {
    if (value === undefined || value === null) return false;
    const str = String(value).trim().toLowerCase();
    return str === '是' || str === '1' || str === 'true' || str === 'yes';
};

const {confirm} = Modal;

export default class dormitory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mkbz: 'GD023_2', // GD023_2: 天狮学院入学教育环节代码
            hjmc: '',
            operable: true,//是否显示环节
            isAllPay: true,
            xsssruYwxx: [],
            jgfsx:'',
            sfxsxz: true,//是否显示须知
            xznr: {},//须知内容
            countdown: 10, // 倒计时秒数（可用参数设置，默认设为10秒）
            timer: null, // 定时器实例，用于清除倒计时
            isForceRead: false, // 是否强制阅读模式
            hasScrolled: false, // 用户是否已发生滚动动作
            isConfigReady: false, // 配置是否加载完成（防止配置返回前用户提前点击）
            hasConfirmedRead: false, // GD023_2专用：标记用户是否已手动确认阅读须知
            isTransact: false,       // GD023_2专用：标记环节是否已办理
            isScrolledToBottom: false, // GD023_2专用：是否已滚动到公告底部
        };
        /** 须知内容容器 ref */
        this.noticeRef = React.createRef();
    }

    componentDidMount() {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        // GD023_2: 移除考试成绩和及格分数线的查询，本环节无考试流程
        this.queryQztjAndYlhj();  // 检查前置条件（开放时段、依赖环节、前置环节）
        this.getRxksxzDetail();   // 获取须知内容和倒计时/强制阅读配置
    }

    componentWillUnmount() {
        // 清除倒计时定时器
        if (this.state.timer) {
            clearInterval(this.state.timer);
        }
        // 移除滚动事件监听，防止内存泄漏
        if (this.noticeRef.current) {
            this.noticeRef.current.removeEventListener('scroll', this.handleScroll);
        }
    }

    /**
     * 启动倒计时
     * 强制阅读模式下，若用户未发生滚动且内容需要滚动，则暂不启动
     */
    startCountdown = () => {
        const { isForceRead, hasScrolled } = this.state;
        // 强制阅读模式下，未发生滚动且内容需要滚动时不启动倒计时
        if (isForceRead && !hasScrolled && this.checkNeedScroll()) {
            return;
        }
        // 清除已有定时器（防止重复创建）
        if (this.state.timer) {
            clearInterval(this.state.timer);
        }
        // 创建新定时器，每秒更新倒计时
        const timer = setInterval(() => {
            this.setState(prevState => {
                // 倒计时结束：清除定时器
                if (prevState.countdown <= 1) {
                    clearInterval(timer);
                    return {
                        countdown: 0,
                        // GD023_2: 天狮学院需求，倒计时结束后不自动关闭须知，需用户手动点击确认阅读
                        timer: null
                    };
                }
                // 倒计时未结束：秒数减1
                return { countdown: prevState.countdown - 1 };
            });
        }, 1000);
        // 保存定时器实例到状态
        this.setState({ timer });
    };
    

    //查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            this.setState({
                nonOperationalData: { nologin: true },
                operable: false,
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid })
            .then(res => {
                if (res && res.data) {
                    let kfsj = res.data['kfsj'];
                    let ylhj = res.data['ylhj'];
                    let qzhj = res.data['qzhj'];
                    this.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        this.setState({ operable: false });
                    }
                }
            });
    }

    //查询学生入学教育考试成绩

    getUserCjById = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        const zzbdhjid = this.getUrlParams("pkid");
        const taskcsbz = "YXXT_RXJYKS_TASKID";
        const jgfcsbz = "YXXT_RXJYKS_JGF";
        NHFetch('/questionnaire/getUserCjById', 'GET', {
            zzbdhjid:zzbdhjid,
            taskcsbz:taskcsbz,
            jgfcsbz:jgfcsbz,
            xsid: xsid
        })
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        xsssruYwxx: res.data
                    });
                    this.refs.siderMenu.reloadMenuList()
                }
            });
    };


    //环节pkid
    getQueryString = (name) => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    //获取url中传递的参数
    getUrlParams = (param) => {
        return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    };

    setMenuList = (menuList) => {
        console.log('[GD023_2] setMenuList 接收数据:', menuList);
        let nextCount = 0;
        let bz = this.state.mkbz;
        let matched = false;
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                console.log('[GD023_2] 匹配到当前环节:', elem.HJMC, 'index:', index);
                let hjmc = elem.HJMC;
                this.setState({ hjmc: hjmc })
                nextCount = index + 1;
                matched = true;
                return;
            }
        });
        if (!matched) {
            console.warn('[GD023_2] 未在 menuList 中匹配到环节代码:', bz);
        }
        let menu = menuList[nextCount];
        console.log('[GD023_2] 下一个环节:', menu);
        if (menu) {
            let hjdm = menu.HJDM;
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm];
                console.log('[GD023_2] 路由映射结果:', hjdm, '->', gdUrl);
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID,
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
                })
            } else if(hjdm.indexOf('DCWJ')==0){
                let wjUrl  = "/customizeExamination";
                this.setState({
                    nextUrl:wjUrl,
                    search:'pkid='+menu.PKID+'&mkbz='+hjdm,
                })
            }
        } else {
            console.warn('[GD023_2] GD023_2 是最后一个环节，无 nextUrl');
            this.setState({
                nextUrl: '',
                search: '',
            })
        }
    }

    getJgfsx =()=>{
        let params = {csbz: "YXXT_RXJYKS_JGF"};
        NHFetch('/zzbdCommon/getCssz', 'GET', params)
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        jgfsx:res.data
                    })
                } else {
                    message.error('未获取及格分数线，请联系管理员！');
                }
            });
    }
    /**
     * 获取倒计时秒数配置
     * @returns {Promise} 请求 Promise
     */
    getCountdown = () => {
        let params = { csbz: CONFIG.COUNTDOWN_CSZB };
        return NHFetch('/zzbdCommon/getCssz', 'GET', params)
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        countdown: res.data
                    });
                }
            });
    };

    /**
     * 获取强制阅读配置
     * @returns {Promise} 请求 Promise
     */
    getForceReadConfig = () => {
        let params = { csbz: CONFIG.FORCE_READ_CSZB };
        return NHFetch('/zzbdCommon/getCssz', 'GET', params)
            .then(res => {
                const isForceRead = res && isValueYes(res.data);
                this.setState({ isForceRead });
            });
    };

    /**
     * 滚动事件监听处理
     * GD023_2: 一滚动就启动倒计时，但必须滚动到底按钮才开放
     */
    handleScroll = () => {
        const { hasScrolled, isForceRead, isScrolledToBottom } = this.state;
        if (!isForceRead) return;

        const el = this.noticeRef.current;
        if (!el) return;

        // 检测是否滚动到底部（容差 5px）
        const scrolledToBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 5;

        // 首次发生滚动时启动倒计时（保持原有行为）
        if (!hasScrolled) {
            this.setState({ hasScrolled: true }, () => {
                this.startCountdown();
            });
        }

        // 滚动到底时更新状态
        if (scrolledToBottom && !isScrolledToBottom) {
            this.setState({ isScrolledToBottom: true });
        }
    };

    /**
     * 检测容器内容是否需要滚动才能看完
     * @returns {boolean} true 表示内容超出容器，需要滚动
     */
    checkNeedScroll = () => {
        const el = this.noticeRef.current;
        if (!el) return false;
        return el.scrollHeight > el.clientHeight;
    };

    startStudy =()=>{
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        const taskcsbz = "YXXT_RXJYKS_TASKID";
        const ksrkcsbz = "YXXT_KSRK_HBDX";
        let params = {ksrkcsbz: ksrkcsbz,taskcsbz: taskcsbz,xsid: xsid};
        NHFetch('/questionnaire/getKsrk', 'GET', params)
            .then(res => {
                if (res && res.data) {
                    if(res.data != "-1"){
                        window.open(res.data);
                        const getUserCjById = this.getUserCjById;

                        confirm({
                            title: '是否完成入学教育考试?',
                            okText: '已完成',
                            okType: 'success',
                            cancelText: '未完成',
                            onOk() {
                                getUserCjById(true);
                            },
                            onCancel() {
                                getUserCjById(true);
                            },
                        });
                    }else{
                        message.error('你没有参与考试资格，请联系管理员！');
                    }
                } else {
                    message.error('未获取考试入口，请联系管理员！');
                }
            });


    }

    /**
     * 获取入学考试须知详情
     * 强制阅读模式下需等待用户滚动后才启动倒计时；若内容过短无需滚动则自动启动
     */
    getRxksxzDetail = () => {
        NHFetch("/xxfb/getRxksxzDetail", "GET")
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        sfxsxz: true,//是否显示须知
                        xznr: res.data,//须知内容
                        isConfigReady: false,//配置加载中，按钮默认禁用
                    }, () => {
                        // 并行获取倒计时配置和强制阅读配置，待两者都返回后再决定倒计时行为
                        Promise.all([this.getCountdown(), this.getForceReadConfig()])
                            .then(() => {
                                this.setState({ isConfigReady: true });
                                // DOM 渲染完成后检测强制阅读逻辑
                                setTimeout(() => {
                                    const { isForceRead } = this.state;
                                    if (isForceRead) {
                                        // 强制阅读模式下，若内容无需滚动则直接视为已到底并启动倒计时
                                        if (!this.checkNeedScroll()) {
                                            this.setState({ isScrolledToBottom: true });
                                            this.startCountdown();
                                        }
                                        // 若内容需要滚动，等待用户滚动触发 handleScroll
                                    } else {
                                        // 非强制阅读模式，立即启动倒计时
                                        this.startCountdown();
                                    }
                                }, 0);
                            })
                            .catch(() => {
                                // 配置请求失败时按非强制阅读处理，避免页面卡死
                                this.setState({ isConfigReady: true });
                                this.startCountdown();
                            });
                    });
                } else {
                    // 清除定时器
                    if (this.state.timer) {
                        clearInterval(this.state.timer);
                    }
                    this.setState({
                        sfxsxz: false,
                        timer: null
                    });
                }
            });
    };

    /**
     * GD023_2专用：标记环节为已办理
     * 调用后端通用接口保存环节办理状态，成功后刷新侧边菜单
     * 复用项目中已有24个组件使用的通用接口模式
     */
    markAsTransacted = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        let zzbdhjid = this.getQueryString('pkid');
        let params = { xsid: xsid, zzbdhjid: zzbdhjid };
        NHFetch('/zzbdCommon/commonSaveLinkTransactionStatus', 'POST', params)
            .then(res => {
                if (res && res.data === 1) {
                    this.setState({ isTransact: true });
                    // 刷新侧边菜单，将当前环节状态更新为"已办理"
                    this.refs.siderMenu.reloadMenuList();
                    message.success('办理成功！');
                } else {
                    message.error('办理环节失败，请稍后重试！');
                }
            })
            .catch(() => {
                message.error('办理环节失败，请稍后重试！');
            });
    };

    /**
     * 手动关闭须知
     * 强制阅读模式下倒计时未结束时禁止关闭
     * GD023_2: 关闭须知后标记环节为已办理
     */
    onChangeSfxsxz = () => {
        const { isForceRead, countdown } = this.state;
        // 强制阅读模式下，倒计时未结束前不允许手动关闭
        if (isForceRead && countdown > 0) {
            return;
        }
        // 清除定时器
        if (this.state.timer) {
            clearInterval(this.state.timer);
        }
        this.setState({
            sfxsxz: false,
            timer: null,
            // GD023_2: 标记用户已手动确认阅读，用于渲染简化页面（无考试表格和考试入口）
            hasConfirmedRead: true
        }, () => {
            // GD023_2: 确认阅读后，调用通用接口将环节标记为已办理，左侧菜单同步显示"已办理"
            this.markAsTransacted();
        });
    };

    render() {
        // GD023_2: 移除 xsssruYwxx、jgfsx 等考试相关状态解构
        const { sfxsxz, xznr, isForceRead, countdown, isConfigReady } = this.state;

        // GD023_2: 按钮禁用条件 = 配置未就绪 / 倒计时未结束 / 未滚动到底
        const isButtonDisabled = !isConfigReady
            || (isForceRead && countdown > 0)
            || (isForceRead && !this.state.isScrolledToBottom);
        // GD023_2: 强制阅读模式下未滚动到底时显示提示
        const showScrollHint = isForceRead && !this.state.isScrolledToBottom;

        return (
            <div styleName="page_buy">
                {this.state.operable ?
                sfxsxz ?<Flex className="w1180 mt-20" align="start">
                      <SiderMenu
                          ref={"siderMenu"}
                          setMenuList={this.setMenuList}
                          title="自助报到"
                          mkbz={this.state.mkbz}
                          /*       active={1}*/
                          menuType="自助报到"
                      />
                      <Flex.Item className="page_con_r">
                       <div styleName="top">
                            <div styleName="title">{xznr.tzbt}</div>
                        </div>
                        <div styleName="con notice-scroll-container" ref={this.noticeRef} onScroll={this.handleScroll}>
                            <div dangerouslySetInnerHTML={{__html:xznr.tznr}} ></div>
                        </div>
                        {showScrollHint && (
                            <div styleName="scroll-hint">请滚动阅读内容后，倒计时才开始</div>
                        )}
                        <div className="text-center mt-50">
                            <Button
                                onClick={this.onChangeSfxsxz}
                                type="primary"
                                className="ml-20"
                                htmlType="submit"
                                disabled={isButtonDisabled}
                            >
                                确认阅读
                                {/* GD023_2: 显示倒计时提示文案 */}
                                {countdown > 0 && (
                                    <span style={{ marginLeft: 10 }}>
                                        （{countdown}秒后可点击确认）
                                    </span>
                                )}
                            </Button>
                        </div>
                      </Flex.Item>
                  </Flex> :
                    <Flex className="w1180 mt-20" align="start">
                        <SiderMenu
                            ref={"siderMenu"}
                            setMenuList={this.setMenuList}
                            title="自助报到"
                            mkbz={this.state.mkbz}
                            /*       active={1}*/
                            menuType="自助报到"
                        />
                        <Flex.Item className="page_con_r">
                            <Breadcrumb
                                noLine
                                list={[
                                    { name: '首页', url: '/index' },
                                    { name: '自助报到', url: '/register' },
                                    { name: this.state.hjmc }
                                ]}
                            />
                            <div className="box">
                                <Hint />
                                <TitleTop title={this.state.hjmc} extra={false} />
                                <div className="p-sw">
                                    <div className="text-center mt-50" style={{ padding: '40px 0' }}>
                                        <p style={{ fontSize: 16, color: '#666', marginBottom: 30 }}>
                                            您已完成入学须知阅读。
                                        </p>
                                        <NextButton nextUrl={this.state.nextUrl} search={this.state.search}/>
                                    </div>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    : <CommonTip hjmc={"入学考试"} key={"GD023_2"} mkbz='GD023_2' nonOperationalData={this.state.nonOperationalData} />}
            </div>
        );
    }
}
